import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getStoredUser, logout } from "../services/Request";
import { FaIdCard, FaUsers, FaSignOutAlt, FaShieldAlt } from "react-icons/fa";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getStoredUser();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header style={styles.header} className="no-print">
      <div style={styles.container}>
        {/* Brand */}
        <Link to="/dashboard" style={styles.brand}>
          <div style={styles.logoBadge}>
            <FaShieldAlt style={{ fontSize: "20px", color: "#10B981" }} />
          </div>
          <div>
            <div style={styles.brandTitle}>NIN VERIFY</div>
            <div style={styles.brandSubtitle}>National Identity Portal</div>
          </div>
        </Link>

        {/* Navigation items */}
        {user ? (
          <div style={styles.navRight}>
            <nav style={styles.navLinks}>
              <Link
                to="/dashboard"
                style={{
                  ...styles.navLink,
                  ...(isActive("/dashboard") || isActive("/verify-nin")
                    ? styles.activeNavLink
                    : {}),
                }}
              >
                <FaIdCard style={{ marginRight: "6px" }} />
                NIN Verification
              </Link>

              {user.role === "admin" && (
                <Link
                  to="/admin/users"
                  style={{
                    ...styles.navLink,
                    ...(isActive("/admin/users") ? styles.activeNavLink : {}),
                  }}
                >
                  <FaUsers style={{ marginRight: "6px" }} />
                  User Management
                </Link>
              )}
            </nav>

            <div style={styles.userSection}>
              <div style={styles.userBadge}>
                <div style={styles.avatar}>
                  {user.name ? user.name.charAt(0).toUpperCase() : "U"}
                </div>
                <div style={styles.userInfo}>
                  <span style={styles.userName}>{user.name || user.email}</span>
                  <span
                    style={{
                      ...styles.userRole,
                      backgroundColor:
                        user.role === "admin" ? "#FEF3C7" : "#E0F2FE",
                      color: user.role === "admin" ? "#92400E" : "#0369A1",
                    }}
                  >
                    {user.role === "admin" ? "ADMIN" : "OFFICER"}
                  </span>
                </div>
              </div>

              <button
                onClick={handleLogout}
                style={styles.logoutBtn}
                title="Log out of portal"
              >
                <FaSignOutAlt style={{ marginRight: "6px" }} />
                Sign Out
              </button>
            </div>
          </div>
        ) : (
          <div style={styles.navRight}>
            <Link to="/login" style={styles.loginBtn}>
              Sign In
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}

const styles = {
  header: {
    backgroundColor: "#FFFFFF",
    borderBottom: "1px solid #E2E8F0",
    position: "sticky",
    top: 0,
    zIndex: 100,
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05)",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 24px",
    height: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    textDecoration: "none",
  },
  logoBadge: {
    width: "44px",
    height: "44px",
    borderRadius: "12px",
    backgroundColor: "#064E3B",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 6px -1px rgba(6, 78, 59, 0.2)",
  },
  brandTitle: {
    fontSize: "19px",
    fontWeight: "800",
    letterSpacing: "-0.5px",
    color: "#064E3B",
    lineHeight: 1.1,
  },
  brandSubtitle: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#64748B",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  navRight: {
    display: "flex",
    alignItems: "center",
    gap: "28px",
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  navLink: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#475569",
    borderRadius: "8px",
    transition: "all 0.2s ease",
  },
  activeNavLink: {
    backgroundColor: "#ECFDF5",
    color: "#064E3B",
  },
  userSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    paddingLeft: "16px",
    borderLeft: "1px solid #E2E8F0",
  },
  userBadge: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  avatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "#064E3B",
    color: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: "14px",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
  },
  userName: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#1E293B",
    maxWidth: "140px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userRole: {
    fontSize: "10px",
    fontWeight: "700",
    padding: "1px 6px",
    borderRadius: "4px",
    width: "fit-content",
    marginTop: "2px",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    padding: "7px 14px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#DC2626",
    backgroundColor: "#FEF2F2",
    border: "1px solid #FEE2E2",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  loginBtn: {
    display: "inline-flex",
    alignItems: "center",
    padding: "9px 20px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#FFFFFF",
    backgroundColor: "#064E3B",
    borderRadius: "8px",
    transition: "background-color 0.2s",
  },
};
